import React from "react";

import { formatCurrency } from "../../../../../utils";
import { rowDateText, rowTitleOf } from "./format";
import { ProgressAmount } from "./ProgressAmount";
import { ProgressEarnedChip } from "./ProgressEarnedChip";
import { ProgressLock } from "./ProgressLock";
import { MobileLine, MobileRow, MobileTitle } from "./styles";
import { ProgressTableCardProps } from "./types";

const ProgressTableCardComponent: React.FC<ProgressTableCardProps> = ({
  row,
  onOpen,
}) => {
  const balanceText =
    row.balanceAfter === null
      ? "Balance unchanged"
      : `Balance ${formatCurrency(row.balanceAfter)}`;
  const extra =
    row.cashbackEarned === null ? (
      <ProgressLock row={row} actions={null} />
    ) : (
      <ProgressEarnedChip cashbackEarned={row.cashbackEarned} />
    );
  const hasExtra = row.cashbackEarned !== null || row.lockLabel !== null;

  return (
    <MobileRow
      type="button"
      onClick={() => onOpen(row)}
      data-testid={`progress-row-${row.key}`}
    >
      <MobileLine>
        <MobileTitle>{rowTitleOf(row)}</MobileTitle>
        <ProgressAmount row={row} />
      </MobileLine>
      <MobileLine $isSub>
        <span>{rowDateText(row.date)}</span>
        <span>{balanceText}</span>
      </MobileLine>
      {hasExtra && <MobileLine $isSub>{extra}</MobileLine>}
    </MobileRow>
  );
};

export const ProgressTableCard = React.memo(ProgressTableCardComponent);
